module.exports = __webpack_public_path__ + "img/price.88e3d876.jpg";